export default __webpack_public_path__ + "static/media/ubisoft_icon_display.c2daab66.svg";